import {ModosOp} from "../../isp._comun/iu/_principal/constantesIuPrin";
import { TipoItem, Moneda, Udm } from "../../isp.žapi.servicios/constantesApiServicios";

//Si no hay input para el Dialogo de Servicio
const getEstadoInicial = () => {
    return {
        domain: {
            screen:{
                idServicio: "-------",
                minicodigo: "-------",
                fechaReg: "--/--/--",
                estadoDeudor: "-------",
                estadoAct: "-------",

                idCliente: "-------",
                nroCliente: "-------",
                nomCliente: "-------",
                idPlan: "-------",
                nomPlan: "-------",
                
                idZona: "-------",
                nomZona: "-------",
                direccion: "",
                
                tipoComp: TipoItem.PlanInternet,
                cicloFact: TipoItem.PlanInternet,
                ptoPon: "",
                cajaDistrib: "",
                nroSeONT: "",
                // moneda: Moneda.Soles,
                // udm: Udm.Mensual,
                /* combos:{
                    udms:[Udm.Mensual],
                    tiposItem:[TipoItem.PlanInternet,TipoItem.ServiciosGen, TipoItem.Articulo]
                } */
            },
            cargado: {}, //Data de una entidad cargada en el dialogo desde la Base de Datos
            update: {}, //Solo tiene data temporal del dominio va a modificar una entidad
            nroUpdates: 0,
        },
        error: {
            nomBlanc: false,
            nomMF: false,
            descripMF: false,
            precioBlanc: false,
            precioMF: false,
            /* rsocialBlanc: false,
            rsocialMF: false,
            rucBlanc: false,
            rucMF: false,
            telcel1Blanc: false,
            telcel1MF: false,
            telcel2MF: false,
            telfijoMF: false,
            emailMF: false,
            sitioWebMF: false, */
        },
        flag: {
            modoOperacion: ModosOp.CREAR,
            procesandoComando: false,
            modal: false,
            cargandoEntidad: false,
            sensorForceUpdate:false
            // iniciando: true
            // sensorDeAccionGuardar: false,
            // sensorDeAccionActualizar: false,
        },
    };
};

export default getEstadoInicial;
